
  export const initContentHeight = (initThis)  => {

       initThis.$nextTick(() => {

       window.addEventListener('resize',function(){

       initHeight(initThis);
        
      },300)

       initHeight(initThis);
        

    })

    }

const initHeight = (initThis) => {

      let clientHeight = document.documentElement.clientHeight;
      let tableHeight = clientHeight-220; 
      initThis.tableHeight = tableHeight;

}

export const dateConvertTime = (time)  => {

    if (time <= 0 || time == undefined || time =='') {
        return '';
    } else {
        var date = new Date();
        date.setTime(time);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        var day = date.getDate();
        var hours = date.getHours();       //获取当前小时数(0-23)
        hours = hours < 10 ? '0' + hours : hours;
        var minutes = date.getMinutes();     //获取当前分钟数(0-59)
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var seconds = date.getSeconds();     //获取当前秒数(0-59)
        seconds = seconds < 10 ? '0' + seconds : seconds;
        day = day < 10 ? '0' + day : day;
        date = year + '-' +  month + '-' + day +' '+hours+':'+minutes+':'+seconds;
        return date;
    }
}

export const dateConvertDate = (time)  => {

    if (time <= 0 || time == undefined || time =='') {
        return '';
    } else {
        var date = new Date();
        date.setTime(time);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        var day = date.getDate();
        var hours = date.getHours();       //获取当前小时数(0-23)
        hours = hours < 10 ? '0' + hours : hours;
        var minutes = date.getMinutes();     //获取当前分钟数(0-59)
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var seconds = date.getSeconds();     //获取当前秒数(0-59)
        seconds = seconds < 10 ? '0' + seconds : seconds;
        day = day < 10 ? '0' + day : day;
        date = year + '-' +  month + '-' + day;
        return date;
    }
}

// 方法1: 使用 Date 对象
export const formatDate = (dateString) =>{

  const date = new Date(dateString);
  
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  
  return `${year}/${month}/${day}`;
}

export const getApiUrl = (time)  => {

   return process.env.VUE_APP_BASE_API;
}

export const getImageUrl = (time)  => {

   return process.env.VUE_APP_BASE_IMAGE;
}


export default {
  initContentHeight,
  dateConvertDate,
  dateConvertTime,
  formatDate,
  getApiUrl,
  getImageUrl
};


// WEBPACK FOOTER //
// ./src/utils/comutil.js